export class CampsImagesModel{
    id?: number;
    campingId?: number;
    imageURL?:string;
    isMainImage?:boolean;
    
   


    constructor(item?:CampsImagesModel){
        item = item? item:{};
        this.id = item.id? item.id:0;
        this.campingId = item.campingId? item.campingId:0;
        this.imageURL = item.imageURL? item.imageURL:'';
        this.isMainImage = item.isMainImage? item.isMainImage:false;
     
        
    
    }

}